<div *ngIf="!hasHidePaymentIcons" class="payment-preview-wrapper" aria-hidden="true">
    <div class="payment-preview" (click)="onClick()">
        <div *ngFor="let icon of paymentMethodIcons" class="payment-preview__icon {{icon.class}}" [title]="icon.translation | translate | striphtml">
            <payment-icons [icon]="icon.icon"></payment-icons>
            <span
                [innerHTML]="icon.translation | translate"></span>
        </div>
    </div>
</div>
